<eif-invitation-screen
	[invitationScreenType]="'supplierFactoring'"
	[token]="token"
	[invitingCompany]="invitingCompany"
	[invitedCompany]="invitedCompany"
	[invitedUser]="invitedUser"
	[invitedUserEmail]="invitedUserEmail"
	[registerUserInput]="registerUserInput"
	[newUser]="newUser"
	[languageCodes]="languageCodes"
	[timeZones]="timeZones"
	[pageDisplayLanguageCode]="pageDisplayLanguageCode"
	(acceptInvitation)="onAcceptInvitation($event)"
	(refuseInvitation)="onRefuseInvitation($event)"
	(documentsUpdated)="onDocumentsUpdated($event)"
	(pageDisplayLanguageCodeChange)="onPageDisplayLanguageCodeChange($event)"
	[showSucessSubmission]="showSucessSubmission"
	[sucessSubmissionContent]="sucessSubmissionContent"
	[requestErrors]="requestErrors"
	[isSubmittingAccept]="isSubmittingAccept"
	[isSubmittingRefuse]="isSubmittingRefuse">
</eif-invitation-screen>
